import React, { useEffect, useState } from "react";

import { roomFacilitesColumns, roomFacilitesData } from "./RoomFacilitesData";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import api from "../../../../../../api/axios";

const RoomFacilitesTable = ({ data, loading, onEdit, onDelete }) => {
  if (loading) return <p>Loading facilities...</p>;

  if (!data.length) return <p>No facilities found.</p>;

  const dataT = data.map((data, index) => {
    return {
      facilitesId: index + 1,
      facilitesName: data.name,
      actions: (
        <>
          <button
            type="button"
            className="btn"
            data-bs-toggle="modal"
            data-bs-target="#edit-facilites"
            onClick={() => onEdit(data)}
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button
            type="button"
            onClick={() => onDelete(data.id)}
            className="btn deleterow"
          >
            <i className="bi bi-trash text-danger"></i>
          </button>
        </>
      ),
    };
  });

  return (
    <>
      <DataTableHeader />
      <DataTable columns={roomFacilitesColumns} data={dataT} />
      <DataTableFooter dataT={dataT} />
    </>
  );
};

export default RoomFacilitesTable;
